module.exports = __webpack_public_path__ + "img/circle.46ad15e5.svg";